.container {
  display: flex;
  justify-content: space-between;
}

.options {
  display: flex;
  gap: 6px;
}
